import React from 'react';

function sourceLabel(source) {
  if (source === 'plaid') return 'Bank';
  if (source === 'gmail') return 'Gmail';
  if (source === 'rules') return 'Rules';
  return 'Document';
}

function formatWhen(value) {
  const text = String(value || '');
  if (!text) return '';
  return text.slice(0, 10);
}

export default function NeverOverpayTimeline({ timeline = [], path = [], empty = 'No mail or bank events linked yet.' }) {
  if (!timeline.length && !path.length) {
    return <p className="np-muted">{empty}</p>;
  }
  return (
    <div data-testid="neveroverpay-timeline">
      {path.length ? (
        <ol className="np-obligation-path">
          {path.map((step) => (
            <li key={step.id || step.label}>
              <span>{step.label}</span>
            </li>
          ))}
        </ol>
      ) : null}
      {timeline.length ? (
        <ul className="np-timeline">
          {timeline.map((row, idx) => (
            <li key={`${row.kind}-${row.at}-${idx}`}>
              <div className="np-timeline-when">{formatWhen(row.at)}</div>
              <div>
                <span className={`np-pill source-${row.source || 'document'}`}>{sourceLabel(row.source)}</span>
                <div style={{ marginTop: 6 }}>{row.title}</div>
                {row.detail ? <p className="np-muted" style={{ marginTop: 4 }}>{row.detail}</p> : null}
              </div>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
